import api from '../axiosConfig';
import { NOTIFICATIONS } from '../config/apiEndpoints';

export const NotificationService = {
    /**
     * Fetch the user's inbox notifications.
     * @param {string} tenantId - The active tenant identifier.
     * @returns {Promise<Array>} - The list of notifications.
     */
    getInboxNotifications: async (tenantId, params = {}) => {
        try {
            const axiosParams = { ...params };
            if (params.page !== undefined) {
                axiosParams.page = params.page + 1;
            } else if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                axiosParams.noPagination = true;
            }
            if (params.limit) axiosParams.limit = params.limit;

            const response = await api.get(NOTIFICATIONS.BASE, {
                params: axiosParams,
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            const data = response.data;
            if (params.page !== undefined) return data;
            return data.data || data;
        } catch (error) {
            console.error('NotificationService getInboxNotifications error:', error);
            throw error;
        }
    },

    markAllRead: async (tenantId) => {
        try {
            const response = await api.post(NOTIFICATIONS.READ_ALL, {}, {
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            return response.data;
        } catch (error) {
            console.error('NotificationService markAllRead error:', error);
            throw error;
        }
    },

    getUnreadCount: async (tenantId) => {
        try {
            const response = await api.get(NOTIFICATIONS.UNREAD_COUNT, {
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            const data = response.data;
            if (data?.data?.count !== undefined) return data.data.count;
            return typeof data.data === 'number' ? data.data : (data.unreadCount || 0);
        } catch (error) {
            console.error('NotificationService getUnreadCount error:', error);
            throw error;
        }
    },

    registerPushToken: async (tokenData, tenantId) => {
        try {
            const response = await api.post(NOTIFICATIONS.PUSH_REGISTER, tokenData, {
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            return response.data;
        } catch (error) {
            console.error('NotificationService registerPushToken error:', error);
            throw error;
        }
    },

    unregisterPushToken: async (tokenData, tenantId) => {
        try {
            const response = await api.post(NOTIFICATIONS.PUSH_UNREGISTER, tokenData, {
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            return response.data;
        } catch (error) {
            console.error('NotificationService unregisterPushToken error:', error);
            throw error;
        }
    },

    getNotificationHistory: async (params, tenantId) => {
        try {
            const axiosParams = { ...params };
            if (params.page !== undefined) {
                axiosParams.page = params.page + 1;
            } else if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                axiosParams.noPagination = true;
            }
            const response = await api.get(NOTIFICATIONS.HISTORY, {
                params: axiosParams,
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            if (params.page !== undefined) return response.data;
            return response.data;
        } catch (error) {
            console.error('NotificationService getNotificationHistory error:', error);
            throw error;
        }
    },

    retryNotification: async (id, tenantId) => {
        try {
            const response = await api.post(NOTIFICATIONS.RETRY_HISTORY(id), {}, {
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            return response.data;
        } catch (error) {
            console.error('NotificationService retryNotification error:', error);
            throw error;
        }
    },

    simulateEvent: async (eventData, tenantId) => {
        try {
            const response = await api.post(NOTIFICATIONS.TEST_EVENT, eventData, {
               headers: tenantId ? { 'x-tenant-id': tenantId } : {}
            });
            return response.data;
        } catch (error) {
            console.error('NotificationService simulateEvent error:', error);
            throw error;
        }
    }
};
